import {
    Sprout,
    Handshake,
    Lightbulb,
    Globe,
    Heart,
    Wheat,
    Beef,
    Factory,
    UserCog,
    GraduationCap,
    Tractor,
    Truck,
    FlaskConical,
    Warehouse,
} from 'lucide-react'

export const iconMap = {
    Sprout,
    Handshake,
    Lightbulb,
    Globe,
    Heart,
    Wheat,
    Beef,
    Factory,
    UserCog,
    GraduationCap,
    Tractor,
    Truck,
    FlaskConical,
    Warehouse,
}

export const getIcon = (name) => iconMap[name] || Sprout
